import * as unregisteredShopActions from '../actions/UnregisteredShops';

const initialState = {
  unregisteredShops: [],
  preShops: [],
  offset: 0,
  limit: 10,
  totalCount: 7,
  detail: {
    unregisteredShopId: 1,
    unregisteredShopName: '店舗１',
    zipCode: '819-0000',
    countryCode: 'JP',
    prefectures: '福岡県',
    city: '福岡市中央区',
    address: '今泉1-20-2',
    building: 'MENTビル4F',
    phone: '090-0000-0000',
    email: 'test@test.com',
    businessHours: '17:00 - 22:00',
    holiday: '土日',
    access: '西鉄福岡天神駅から徒歩5分',
    webPage: 'https://www.test.com/',
    latitude: '33.586565',
    longitude: '130.398734',
    geohash: 'abcdefg',
    comment: 'コメント',
    registerUserId: 1,
    status: '本登録済',
    message: '応援しています！',
    tags: [
      {
        tagId: 1,
        tagName: 'タグ1',
        viewOrder: 1
      },
      {
        tagId: 2,
        tagName: 'タグ2',
        viewOrder: 2
      },
      {
        tagId: 3,
        tagName: 'タグ3',
        viewOrder: 3
      },
      {
        tagId: 4,
        tagName: 'タグ4',
        viewOrder: 4
      },
      {
        tagId: 5,
        tagName: 'タグ5',
        viewOrder: 5
      },
      {
        tagId: 6,
        tagName: 'タグ6',
        viewOrder: 6
      }
    ],
    preGochis: [
      {
        gochiBillId: 1,
        shopId: 1,
        accountId: 'gochi taro',
        displayName: 'ごち太郎',
        gochiRegisterId: 1,
        type: 'PRICE',
        paymentId: 1,
        amount: 500,
        taxRate: 0.1,
        taxAmount: 50,
        feeRate: 0.1,
        feeAmount: 55,
        status: '登録済',
        createdAt: '2019-09-10 12:00:00'
      },
      {
        gochiBillId: 2,
        shopId: 2,
        accountId: 'gochi taro',
        displayName: 'ごち花子',
        gochiRegisterId: 2,
        type: 'PRICE',
        paymentId: 2,
        amount: 700,
        taxRate: 0.1,
        taxAmount: 70,
        feeRate: 0.1,
        feeAmount: 77,
        status: '登録済',
        createdAt: '2019-09-11 12:00:00'
      },
      {
        gochiBillId: 3,
        shopId: 3,
        accountId: 'gochi taro',
        displayName: 'ごち太郎',
        gochiRegisterId: 3,
        type: 'PRICE',
        paymentId: 3,
        amount: 800,
        taxRate: 0.1,
        taxAmount: 80,
        feeRate: 0.1,
        feeAmount: 88,
        status: '登録済',
        createdAt: '2019-09-12 12:00:00'
      }
    ],
    images: [
      {
        image:
          'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/shop/restaurant1.png',
        viewOrder: 1,
        status: 'REPORTED'
      },
      {
        image:
          'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/shop/restaurant2.png',
        viewOrder: 2,
        status: 'REPORTED'
      }
    ],
    createdAt: '2019-08-30 12:00:00'
  },
  error: false,
  status: 200,
  error_message: ''
};

const unregisteredShops = (state = initialState, action) => {
  switch (action.type) {
    case unregisteredShopActions.GET_UNREGISTERED_SHOPS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case unregisteredShopActions.GET_UNREGISTERED_SHOPS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case unregisteredShopActions.GET_UNREGISTERED_SHOP_DETAIL_SUCCESS:
      return Object.assign({}, state, { detail: action.payload });
    case unregisteredShopActions.GET_UNREGISTERED_SHOP_DETAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default unregisteredShops;
